module.exports = __webpack_public_path__ + "media/images/products/longlife/after-contract-img-1-ca4b600bf77c3f1b668310d795f2e188.png";